export default __webpack_public_path__ + "static/media/authbg.facc3b60.jpg";